import { TaskNotificationStatus } from '@backoffice-frontend/graphql'

export const fleetMapAlertStatus = [
  TaskNotificationStatus.New,
  TaskNotificationStatus.InProgress,
  TaskNotificationStatus.Pending,
]
